import React from 'react'
import { PrismicRichText } from '@prismicio/react'
import LiteYouTubeEmbed from 'react-lite-youtube-embed'
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css'

const Video = ({ slice, embed }) => {
  let vimeo = false

  if (embed === null && slice.primary.embed_video === null) return null

  if (slice?.primary?.embed_video) {
    embed = slice.primary.embed_video.embed_url
  }

  // YouTube
  if (embed?.includes('watch')) {
    embed = embed.split('v=')[1]
    var ampersandPosition = embed.indexOf('&')
    if (ampersandPosition !== -1) {
      embed = embed.substring(0, ampersandPosition)
    }
  }
  if (embed?.includes('shorts')) {
    embed = embed.split('shorts/')[1]
  }
  if (embed?.includes('youtu.be')) {
    embed = embed.split('youtu.be/')[1]
  }

  // Vimeo
  if (embed?.includes('vimeo')) {
    vimeo = new URL(slice.primary.embed_video.embed_url)
    vimeo.host = 'player.vimeo.com'
    vimeo.pathname = '/video' + vimeo.pathname.replace('/video', '')
  }

  return (
    <section className='component-video mx-auto w-full max-w-screen-lg p-4'>
      <div className='prose prose-lg mb-10 min-w-full text-center'>
        <PrismicRichText field={slice.primary.video_title.richText} />
      </div>
      <div className='relative aspect-video'>
        {embed?.includes('vimeo') ? (
          <iframe
            className='h-full w-full'
            src={`${vimeo.href}?background=1&portrait=0&byline=0`}
            frameBorder='0'
            allow='autoplay; fullscreen; picture-in-picture'
            allowFullScreen
            title={slice.primary.embed_video.title || slice.primary.video_title.text}
          />
        ) : (
          <LiteYouTubeEmbed iframeClass='h-full' id={embed} />
        )}
      </div>
    </section>
  )
}

export default Video
